import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext, API } from '@/App';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { ChevronRight } from 'lucide-react';

const AppList = () => {
  const { token } = useContext(AuthContext);
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchApps();
  }, []);

  const fetchApps = async () => {
    try {
      const response = await axios.get(`${API}/apps?status=active`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setApps(response.data);
    } catch (error) {
      toast.error('Failed to load apps');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-slate-500">Loading apps...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <h2 className="text-xl font-bold mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Available Apps / Aplicaciones Disponibles
        </h2>
        <p className="text-sm text-slate-600">Select an app to complete a form / Seleccione una aplicación para completar un formulario</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {apps.length === 0 ? (
          <div className="col-span-2">
            <Card>
              <CardContent className="py-12 text-center">
                <p className="text-slate-500">No apps available at the moment.</p>
                <p className="text-slate-500 text-sm">No hay aplicaciones disponibles en este momento.</p>
              </CardContent>
            </Card>
          </div>
        ) : (
          apps.map((app) => (
            <Card
              key={app.id}
              className="cursor-pointer hover:shadow-lg transition-all duration-200 border-2 hover:border-slate-300 overflow-hidden"
              onClick={() => navigate(`/field/app/${app.id}`)}
              data-testid="app-card"
            >
              <div className="h-3" style={{ backgroundColor: app.header_color }} />
              <CardHeader className="pb-3">
                <CardTitle className="flex items-center justify-between">
                  <span>{app.name}</span>
                  <ChevronRight className="h-5 w-5 text-slate-400" />
                </CardTitle>
                <CardDescription className="text-base">{app.name_es}</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600">{app.description}</p>
                <p className="text-sm text-slate-500 mt-1">{app.description_es}</p>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export default AppList;